import { render, staticRenderFns } from "./attribute-name.vue?vue&type=template&id=924cd64e&"
import script from "./attribute-name.vue?vue&type=script&lang=js&"
export * from "./attribute-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports